import { create } from 'zustand';

/** 
* Statistic's Zustand Store.
* @summary This Zustand store automatically returns data from whatever function by using the dataFilter, it also automatically clears its data after 24h. 
* @param {String} setDateFilter - `30_days`, `7_days`, `24_hours`, `allTime` 
*/
const useStatisticsStore = create((set, get) => ({
    dataByDateFilter: {
        '30_days': {},
        '7_days': {},
        '24_hours': {},
        'allTime': {},
    },
    timestamps: {
        '30_days': {},
        '7_days': {},
        '24_hours': {},
        'allTime': {},
    },
    dateFilter: '30_days', // Default 30d

    getModuleData: (moduleName) => {
        const state = get();
        const data = state.dataByDateFilter[state.dateFilter][moduleName];
        const timestamp = state.timestamps[state.dateFilter][moduleName];

        if (timestamp && (Date.now() - timestamp) > 86400000) return null;

        return data;
    },

    setModuleData: (moduleName, data) => set((state) => {
        const currentTime = Date.now();
        const updatedDataByDateFilter = {
            ...state.dataByDateFilter,
            [state.dateFilter]: {
                ...state.dataByDateFilter[state.dateFilter],
                [moduleName]: data,
            },
        };
        const updatedTimestamps = {
            ...state.timestamps,
            [state.dateFilter]: {
                ...state.timestamps[state.dateFilter],
                [moduleName]: currentTime,
            },
        };
        return {
            dataByDateFilter: updatedDataByDateFilter,
            timestamps: updatedTimestamps,
        };
    }),

    setDateFilter: (newDateFilter) => set({ dateFilter: newDateFilter }),
    clearAllData: () => set(() => ({
        dataByDateFilter: {
            '30_days': {},
            '7_days': {},
            '24_hours': {},
            'allTime': {},
        },
        timestamps: {
            '30_days': {},
            '7_days': {},
            '24_hours': {},
            'allTime': {},
        },
        dateFilter: '30_days', // Default 30d
    })),
}));

export default useStatisticsStore;